/*
 * Copyright (c) 2025.
 * This code and its derivatives belong to BETICA LTD and may not be copied, reproduced, amended or used in any way without the permission of BETICA LTD
 * @author torrejonv
 *
 */

export class AbstractPriceFormat {
  constructor() {
    this.NO_PRICE = "";
  }

  isNumeric(strTest, decimalSep) {
    const match = /[+-]?(\d+[.,])?\d+([.,]\d*)?/;

    return match.test(strTest.replace(/\s/g, ""));
  }
}
